import { render, staticRenderFns } from "./LabelAdquirirSaldo.vue?vue&type=template&id=3a9e4f84"
import script from "./LabelAdquirirSaldo.vue?vue&type=script&lang=js"
export * from "./LabelAdquirirSaldo.vue?vue&type=script&lang=js"
import style0 from "./LabelAdquirirSaldo.vue?vue&type=style&index=0&id=3a9e4f84&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports